import React, { Component } from "react";
import LoaderImage from "../../images/ajax-loader.gif";

class LoadingIndicatorComponent extends Component {
    render() { 
        return (    
        <div style={{textAlign: "center"}}>
          <img src={LoaderImage} width="200px" height="200px"/><br/> <br/>
          <h4 style={{marginTop:"-50px"}}>Obrada zahteva u toku. Molimo sačekajte.</h4>
        </div>);
    }
}
 
export default LoadingIndicatorComponent;